export enum FundraiserTypeEnum {
  Unknow = -1,
  Memorial = 1, // Minnesgåva
  Gift = 2, // Gåva
  Celebration = 3, // Högtidsgåva
  Fundraiser = 4, // Insamling
}

export const FundraiserTypeEnumLabels = (type: FundraiserTypeEnum, t: (n: string) => string) => {
  switch (type) {
    case FundraiserTypeEnum.Unknow:
      return t('fundraiser:fundraiserType.unknown');
    case FundraiserTypeEnum.Memorial:
      return t('fundraiser:fundraiserType.memorial');
    case FundraiserTypeEnum.Gift:
      return t('fundraiser:fundraiserType.general');
    case FundraiserTypeEnum.Celebration:
      return t('fundraiser:fundraiserType.celebration');
    case FundraiserTypeEnum.Fundraiser:
      return t('fundraiser:fundraiserType.general');
    default:
      return t('fundraiser:fundraiserType.unknown');
  }
};
